export default __webpack_public_path__ + "static/cover-bb8be3807f5ddeedac493e14ba8aa4f6.png";